var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "button",
    _vm._b(
      {
        staticClass: "bmui-selector",
        class: {
          "bmui-selector-checked": _vm.checkedInside,
          "bmui-selector-disabled": _vm.disabled
        },
        attrs: { type: "button", disabled: _vm.disabled },
        on: { click: _vm.click }
      },
      "button",
      _vm.mixinInputProps,
      false
    ),
    [
      _vm._v(
        _vm._s(
          (typeof _vm.item === "string" ? _vm.item : _vm.item.name) || "ITEM"
        )
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-a0234732", { render: render, staticRenderFns: staticRenderFns })
  }
}